import IconButton from '../../Buttons/IconButton'
import styled from 'styled-components'

type AlertButtonProps = {
  icon: string
  tooltip?: string
  badgeCount?: number
  onClick?: () => void
}

const AlertButton = ({ icon = 'bell', tooltip, badgeCount, onClick }: AlertButtonProps) => (
  <Container>
    <IconButtonWrapper badge icon={icon} iconPosition="center" tooltip={tooltip} variant="ghost" onClick={onClick} />
    {!!badgeCount && badgeCount > 0 && <NotificationBadge>{badgeCount > 99 ? `99+` : badgeCount}</NotificationBadge>}
  </Container>
)

const Container = styled.div`
  & * {
    box-sizing: border-box;
  }

  position: relative;
`

const IconButtonWrapper = styled(IconButton)`
  > svg {
    ${(p) => p.theme.font({ color: 'disabledText', size: 16 })}
  }
`

const NotificationBadge = styled.div`
  background-color: ${({ theme }) => theme.colors.orange};
  border-radius: 4px;
  color: white;
  font-size: 12px;
  text-align: center;
  position: absolute;
  top: 0;
  right: 0;
  padding: 3px;
  border-style: solid;
  min-width: 18px;
  transform: translate(60%, -60%);
`

export default AlertButton
